module.exports = require("core-js-pure/features/symbol");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/symbol.js
// module id = 6376
// module chunks = 25